export const APP_VERSION = {
  commitHash: '4cf4fbe',
  pushedAt: '2026-11-04 4:52 PM EST',
};
